var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "START_ANGLE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #START_ANGLE .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #START_ANGLE .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_363",
    "data-name": "Pfad 363",
    className: "cls-1",
    d: "M15.9,1.5,16,12.8l1.1-.1,1.2.8,8.1-8.1L20.8,1.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_996",
    "data-name": "Gruppe 996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_364",
    "data-name": "Pfad 364",
    className: "cls-2",
    d: "M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Zm0,2a14.007,14.007,0,0,1,9.1,3.4L18,12.5a3.805,3.805,0,0,0-1.5-.5h-1a3.83,3.83,0,0,0-3.4,3.4H2A14.061,14.061,0,0,1,16,2Zm3,14a2.946,2.946,0,0,1-3,3,3.019,3.019,0,0,1-3-2.6V16a1.268,1.268,0,0,1,.1-.6,2.87,2.87,0,0,1,2.4-2.3h1a1.854,1.854,0,0,1,.7.2,3.159,3.159,0,0,1,1.4,1.4A1.844,1.844,0,0,1,19,16ZM16,30A14.028,14.028,0,0,1,2,16.4H12a4.011,4.011,0,0,0,8-.4,3.7,3.7,0,0,0-.6-2.1l1.7-1.7H25V8.3l1.6-1.6A14.753,14.753,0,0,1,30,16,14.041,14.041,0,0,1,16,30Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_372",
    "data-name": "Ellipse 372",
    className: "cls-2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(14 14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartAngle);
export default __webpack_public_path__ + "static/media/start-angle.de99499c6f3bd15a0893582015eb4f34.svg";
export { ForwardRef as ReactComponent };